import {atom, useSetRecoilState} from "recoil";
import Modal from "../components/modal";
import TextInput from "../components/text-input";
import PrimaryButton from "../components/primary-button";
import {ChangeEvent, FormEvent, useContext, useState} from "react";
import Row from "../components/row";
import styled from "styled-components";
import Checkmark from "./checkmark";
import FirebaseContext from "../utils/firebase-context";
import * as validator from 'email-validator';

const CreateAccountForm = styled.form`
  display: grid;
  gap: .5rem;
`;

export const CreateAccountModalState = atom({
    key: "CREATE_ACCOUNT_MODAL",
    default: false
});

const emptyFormState = {
    firstName: "",
    lastName: "",
    email: "",
    password: ""
};

export default function CreateAccountModal() {
    const setModalState = useSetRecoilState(CreateAccountModalState);
    const firebase = useContext(FirebaseContext);

    const [sent, setSent] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const [formState, setFormState] = useState(emptyFormState);
    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        setFormState(ls => ({...ls, [e.target.name]: e.target.value}));
    };

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault();
        await sendRequest();
    }

    const validate = () => {
        return validator.validate(formState.email)
            && formState.password.length > 0
            && formState.email.length > 0
            && formState.firstName.length > 0
            && formState.lastName.length > 0;
    };

    const sendRequest = async () => {
        setDisabled(true);
        if (!validate()) return;

        const doc = await firebase.requestAccount(formState);
        if (!!doc) {
            setSent(true);
        }
        setDisabled(false);
    };


    const form = <CreateAccountForm onSubmit={onSubmit}>
        <Row>
            <TextInput
                value={formState.firstName}
                onChange={onChange}
                placeholder={"Vorname"}
                type={"text"}
                name={"firstName"}
            />
            <TextInput
                value={formState.lastName}
                onChange={onChange}
                placeholder={"Nachname"}
                type={"text"}
                name={"lastName"}
            />
        </Row>
        <TextInput
            value={formState.email}
            onChange={onChange}
            placeholder={"Email Adresse"}
            type={"email"}
            name={"email"}
        />
        <TextInput
            value={formState.password}
            onChange={onChange}
            placeholder={"Passwort"}
            type={"password"}
            name={"password"}
        />
        <PrimaryButton disabled={disabled}>
            Anfrage schicken
        </PrimaryButton>
    </CreateAccountForm>

    const success = <div style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
    }}>
        <Checkmark size={60} />
        <div style={{
            marginTop: ".5rem",
            marginBottom: ".3rem",
            fontSize: 18,
            fontWeight: 800
        }}>
            Anfrage verschickt
        </div>
        <div style={{
            width: "75%",
            margin: "auto"
        }}>
            Du erhältst eine Mail, wenn deine Anfrage akzeptiert wurde.
        </div>
    </div>

    return <Modal close={() => setModalState(false)} title={"Account erstellen"}>
        {sent ? success : form}
    </Modal>
}
